// PageProject Component

import React from 'react'
import _ from 'lodash'

import app from '../../../app.jsx'
import eventfilters from '../../../lib/eventfilters.jsx'
import PageBase from '../../../common/page/page_base/page_base.jsx'
import ConfirmDelete from '../../../common/common/confirm_delete/confirm_delete.jsx'
import Button from '../../../common/common/button/button.jsx'
import ContentMessage from '../../../common/common/content_message/content_message.jsx'
import Grid from '../../../common/common/grid/grid.jsx'
import List from '../../../../components/List/List.jsx'
import ProjectForm from '../../form/project_form/project_form.jsx'
import ProjectItem from '../../project/project_item/project_item.jsx'
import ProjectManagerCell from '../../project/project_manager_cell/project_manager_cell.jsx'
import DialogSetting from '../../../contact/dialog/dialog_setting/dialog_setting.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import currency from '../../../lib/currency.jsx'
import ProfilerUtil from '../../../lib/profilerutil.jsx'
import Acl from '../../../lib/acl.jsx'
import PageHeader from '../../../theme/layout/page_header/page_header.jsx'
import DialogExport from '../../../common/dialog/dialog_export/dialog_export.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import { ProjectsIcon } from '../../../common/layout/menu_icons/projects.jsx'

import { AddProjectModal } from './AddProjectModal.jsx'
import SidebarAddclientWizard from '../../../theme/project/sidebar_addclient_wizard/sidebar_addclient_wizard.jsx'
import { getParametersForSaveProject } from './_get_parameters_for_save_project'

class PageProject extends PageBase {
  constructor (props) {
    super(props, 'project', 'project', 'project')

    this.state = {
      isLoading: true,
      dataDate: null,
      project: null,
      bCanDelete: true,
      profilerId: null,
      isShowAddProjectModal: false,
      isShowContactWizard: false,
      isShowProjectError: false,
      isShowProjectNumberError: false
    }

    const appTeam = app.getTeam()
    this.data = {
      projects: [],
      total: 0,
      countLoaded: 0,
      canPaginate: true,
      pageNo: 1,
      pageState: {
        sort: 'title',
        sortAsc: true,
        type: 'grid',
        filter: null
      },
      tagSuggestions: [],
      teamPaymentPeriod:
        appTeam && appTeam.profile ? appTeam.profile.payPeriod : 0,
      filterProjectIds: [],
      bShowForm: false,
      defaultRateCards: [],
      isPlannerAllowed: !!(
        appTeam &&
        appTeam.subscription &&
        appTeam.subscription.isPlannerActive
      ),

      projectName: '',
      clientName: '',
      copyProjectId: '',
      nextProjectNumber: '',
      sidebarProject: null,
      sidebarContact: null,
      documentLanguages: [
        {
          label: 'US',
          value: 'US'
        },
        {
          label: 'NL',
          value: 'NL'
        },
        {
          label: 'DE',
          value: 'DE'
        }
      ],
      addressTypes: [
        {
          label: 'Office',
          value: 'Office'
        },
        {
          label: 'Estimate',
          value: 'Estimate'
        },
        {
          label: 'Invoice',
          value: 'Invoice'
        },
        {
          label: 'PO',
          value: 'PO'
        },
        {
          label: 'Others',
          value: 'Others'
        }
      ]
    }

    this._references = {
      header: React.createRef(),
      projectSettingDialog: React.createRef(),
      confirmDelete: React.createRef(),
      projectform: React.createRef(),
      exportDialog: React.createRef()
    }

    this._setFABButtonState(true, false)
    this._bUnMounted = false

    /* Initialize profiler */
    this._profiler = new ProfilerUtil(this._pageIdent, 2) // Average time 2 seconds
    this._profiler.start()
  }

  componentDidMount () {
    document.body.addEventListener('keydown', this._handleDocumentKeyDown)
    this._getData(false)
    this._initEvents()
    this._triggerAdd()

    // Calculate and save profiler, Hardcode profiler id as 1, since it is the first call of profiler
    this._profiler.stop(1)
  }

  componentWillUnmount () {
    this._releaseEvents()
    document.body.removeEventListener('keydown', this._handleDocumentKeyDown)

    this._profiler = null
    this._bUnMounted = true
  }

  componentDidUpdate (prevProps, prevState) {
    if (
      this._profiler &&
      (!prevState || prevState.profilerId !== this.state.profilerId) &&
      this.state.profilerId
    ) {
      this._profiler.stop(this.state.profilerId)
    }
  }

  renderContent () {
    return (
      <div className='pageinnercont'>
        {this._renderMessage()}
        {this._renderGridOrList()}
        {this._renderProjectForm()}
        {this._renderSettingsDialog()}
        {this._renderSidebars()}
        {this._renderInvoiceDialog()}
      </div>
    )
  }

  getContentClassname () {
    return this.data.pageState.type === 'grid' ? 'alt' : null
  }

  /* Event handlers */
  _handleDocumentKeyDown = evt => {
    if (this.data.bShowForm || this.ignoreAutoSearch) return

    if (
      this._references.header.current &&
      !this.state.isShowAddProjectModal &&
      !this.state.isShowContactWizard
    ) {
      const keyCode = evt.keyCode || 0

      let bSearch = true
      if (
        keyCode === 13 ||
        keyCode === 9 ||
        keyCode === 27 ||
        keyCode === 17 ||
        keyCode === 224
      ) {
        bSearch = false
      } else if (evt.ctrlKey || evt.altKey || evt.shiftKey || evt.metaKey) {
        bSearch = false
      }

      if (keyCode === 27) {
        this._references.header.current.onEscKeyDown()
      } else if (bSearch && this._references.header.current.canShowSearch()) {
        this._references.header.current.showSearch()
      }
    }
  }

  _onGridItemClick (project) {
    let userFavoriteTab = this._getUserFavoriteTab('projectView')
    if (!userFavoriteTab || !Acl.isPageAllowed(userFavoriteTab)) {
      userFavoriteTab = 'projectview-overview'
    }

    if (project && project.id) {
      app.changePage(userFavoriteTab, project.id)
    }
  }

  _onGridItemSettingClick (project) {
    let bCanDelete = true
    app
      .service('/api/project/validatedelete')
      .get(project.id)
      .then(projectRes => {
        if (projectRes.count > 0) {
          bCanDelete = false
        }
        this._onSettingDataReceived(project, bCanDelete)
      })
      .catch(projectErr => {
        app.debug('Page project: _onClickSetting err', projectErr)
      })
  }

  _onSettingDataReceived (project, bCanDelete) {
    this.setState({ project: project, bCanDelete: bCanDelete })
    if (this._references.projectSettingDialog.current) {
      this._references.projectSettingDialog.current.show(
        project.title,
        null,
        null,
        project.status
      )
    }
  }

  _onView (project, e) {
    e.preventDefault()
    if (project && project.id) {
      app.changePage('projectview-overview', project.id)
    }
  }

  _onEdit (project, e) {
    e.preventDefault()

    if (project && project.id && project.status !== 'closed') {
      if (this._references.projectSettingDialog.current) {
        this._references.projectSettingDialog.current.hide()
      }

      if (this._references.projectform.current) {
        const projectSetting = app.projectSetting
        this._references.projectform.current.show(
          project,
          project.projectNumber || '',
          '',
          projectSetting.useProjectNo || false,
          projectSetting.isGenerated || false
        )
      }

      this.data.bShowForm = true
    }
  }

  _onCopy (project, e) {
    e.preventDefault()

    const { id, contact, ...projectData } = project

    const createData = {
      teamId: app.getTeamId(),
      createdById: app.loggedInId,
      contactId: projectData.contactId,
      percentageCompleted: 0,
      status: 'estimate',
      startDate: projectData.startDate ? new Date(projectData.startDate) : null,
      endDate: projectData.endDate ? new Date(projectData.endDate) : null,
      closeDate: projectData.closeDate ? new Date(projectData.closeDate) : null,
      projectNumber: ''
    }

    const copyData = {
      id: project.id,
      projectData: createData,
      subObjects: ['phase', 'activity', 'team'],
      bGetNewTitle: true // Only used for current flow, new flow no need this variable
    }

    app
      .service('/api/project/copy')
      .create(copyData)
      .then(copyRes => {
        if (copyRes) {
          app.changePage('projectview-budget', copyRes.id, 'showedit')
        }
      })
      .catch(copyErr => {
        app.debug(copyErr)
      })
  }

  _onDelete (project, e) {
    e.preventDefault()

    if (project.status !== 'closed') {
      if (this._references.confirmDelete.current) {
        this._references.confirmDelete.current.show()
      }
    }
  }

  _onReopen (project, e) {
    e.preventDefault()
    if (this._references.projectSettingDialog.current) {
      this._references.projectSettingDialog.current.hide()
    }

    app
      .service('/api/project')
      .patch(this.state.project.id, { status: 'completed' })
      .then(_prjRes => {
        this._reloadData()
      })
      .catch(arcErr => {
        app.debug('Page project reopen err', arcErr)
      })
  }

  _onClickDeleteConfirm (e) {
    if (!this.state.project.id) {
      return false
    }

    e.preventDefault()
    app
      .service('/api/project')
      .remove(this.state.project.id)
      .then(_deleteRes => {
        if (this._references.projectSettingDialog.current) {
          this._references.projectSettingDialog.current.hide()
        }
        this.data.pageNo = 1
        this._reloadData()
      })
      .catch(deleteErr => {
        app.debug('Page project delete err', deleteErr)
      })
  }

  _onCloseFilter () {
    this.data.pageState.filter.contact = null
    this.data.pageState.filter.member = null
    this.data.pageState.filter.phaseStatus = ''
    this.data.pageState.filter.status = ''
    this.data.pageState.filter.tags = []
    this.data.pageState.filter.keyword = ''
    this.data.pageNo = 1
    this._reloadData()
  }

  onAdd () {
    const projectSetting = app.projectSetting
    this.data.nextProjectNumber = ''
    this.data.sidebarProject = null
    this.data.sidebarContact = null
    this.data.projectName = ''
    this.data.clientName = ''
    this.data.copyProjectId = ''

    if (projectSetting.useProjectNo) {
      this._getProjectNumber(
        projectSetting.isGenerated,
        null,
        projectNumber => {
          this.data.nextProjectNumber = projectNumber
          this._showAddProjectModal()
        }
      )
    } else {
      this._showAddProjectModal()
    }
  }

  _showAddProjectModal () {
    this._toggleDemoButton(false)
    this._toggleFABButton(false)
    this.setState({
      isShowAddProjectModal: true,
      isShowProjectError: false,
      isShowProjectNumberError: false
    })
  }

  _showClientWizard () {
    this.setState({ isShowContactWizard: true, isShowAddProjectModal: false })
  }

  _onCloseSetting () {
    if (this._references.confirmDelete.current) {
      this._references.confirmDelete.current.hide()
    }
  }

  _onCloseForm () {
    this.data.bShowForm = false
    if (this._references.projectform.current) {
      this._references.projectform.current.hide()
    }
  }

  /* Private functions */
  _renderMessage () {
    let contentMessage = 'project.list.msgErrorTitle'
    let contentInfo = 'project.list.msgErrorContent'
    let prefixClickText = ''
    let bShowPrefixClickText = false

    if (this.data.pageState && this.data.pageState.filter) {
      contentMessage = 'project.list.msgErrorSearchTitle'
      contentInfo = 'project.list.msgErrorSearchContent'
      bShowPrefixClickText = true
      prefixClickText = 'project.list.searchClickText'
    }

    if (!this.state.isLoading && !this.data?.projects?.length) {
      return (
        <ContentMessage
          message={contentMessage}
          info={contentInfo}
          showAddPrefix
          showAdd
          prefixClickText={bShowPrefixClickText ? prefixClickText : null}
          bShowPrefixClickText
          onAdd={this.onAdd.bind(this)}
        />
      )
    }

    return null
  }

  _renderGridOrList () {
    if (this.state.isLoading || !this.data.projects.length) {
      return null
    }

    let bShowLoader = false
    if (this.data.projects && this.data.projects.length < this.data.total) {
      bShowLoader = true
    }

    if (this.data.pageState.type === 'list') {
      return (
        <div className='listwrap'>
          <List
            objectList={this.data.projects}
            sortOptions={this._getSortOptions()}
            columns={this._getListCloumns()}
            onPaginate={this._onPaginate.bind(this)}
            onSort={this._onSort.bind(this)}
            renderCustomCell={this._onRenderList.bind(this)}
            onView={this._onGridItemClick.bind(this)}
            actionIcon='common-action-setting'
            sort={this.data.pageState.sort}
            sortAsc={this.data.pageState.sortAsc}
            onSettings={this._onGridItemSettingClick.bind(this)}
            showLoader={bShowLoader}
          />
        </div>
      )
    }

    return (
      <div className='gridwrap'>
        <Grid
          objectList={this.data.projects}
          sortOptions={this._getSortOptions()}
          onPaginate={this._onPaginate.bind(this)}
          sort={this.data.pageState.sort}
          sortAsc={this.data.pageState.sortAsc}
          showLoader={bShowLoader}
          onSort={this._onSort.bind(this)}
          onRenderGrid={this._onRenderGrid.bind(this)}
        />
      </div>
    )
  }

  _renderSidebars () {
    const { isShowAddProjectModal, isShowContactWizard } = this.state

    return (
      <div className='sidebar-wrapper'>
        {(isShowAddProjectModal || isShowContactWizard) && (
          <div className='sidebaroverlay' />
        )}
        {isShowAddProjectModal && this._renderAddProjectModal()}
        {isShowContactWizard && this._renderClientSidebar()}
      </div>
    )
  }

  _renderAddProjectModal () {
    const projectSetting = app.projectSetting
    return (
      <AddProjectModal
        getActiveClients={this._onGetActiveContacts.bind(this)}
        getProjectNumber={this._getProjectNumber.bind(this)}
        onCreateClient={this._onCreateContact} // eslint-disable-line react/jsx-handler-names
        getClientProjects={this._getContactProjects.bind(this)}
        onSaveProject={this._onSaveProjectDetails} // eslint-disable-line react/jsx-handler-names
        isPmVisible={projectSetting.isPmVisible}
        isPlannerAllowed={this.data.isPlannerAllowed}
        isNumberAutoGenerated={projectSetting.isGenerated}
        isNumberSupported={projectSetting.useProjectNo}
        nextProjectNumber={this.data.nextProjectNumber}
        language={app.language}
        tagSuggestions={this.data.tagSuggestions}
        isOpen={this.state.isShowAddProjectModal}
        onModalClose={this._onCloseAddProjectModal.bind(this)}
      />
    )
  }

  _renderClientSidebar () {
    const {
      projectName,
      clientName,
      sidebarContact,
      addressTypes,
      documentLanguages,
      defaultRateCards
    } = this.data
    return (
      <SidebarAddclientWizard
        projectName={projectName}
        clientName={clientName}
        contact={sidebarContact}
        addressTypes={addressTypes}
        teamCountry={app.teamCountry}
        rateMarkup={app.getDefaulRateMarkup()}
        documentLanguages={documentLanguages}
        defaultRateCards={defaultRateCards}
        isTeamUSA={app.teamCountry === 'US'}
        teamPaymentDays={this.data.teamPaymentPeriod}
        onSaveContact={this._onSaveContactDetails} // eslint-disable-line react/jsx-handler-names
        onCloseContactSidebar={this._onCloseContactSidebar} // eslint-disable-line react/jsx-handler-names
        onClickInfo={this._onClickInfo} // eslint-disable-line react/jsx-handler-names
      />
    )
  }

  _getContactProjects (contactId, callback) {
    const params = {
      query: {
        contactId: contactId
      }
    }

    app
      .service('/api/project')
      .find(params)
      .then(result => {
        if (result) {
          callback(result.data)
        }
      })
      .catch(err => {
        app.debug('PageProject - _getContactProjects Error: ', err)
        callback([]) // eslint-disable-line standard/no-callback-literal
      })
  }

  _getProjectNumber (isGenerated, contactId, callback) {
    const projectParams = {
      query: {
        type: isGenerated ? 'nextProjectNumber' : 'previousProjectNumber',
        contactId: contactId
      }
    }

    app
      .service('/api/page/project')
      .get(null, projectParams)
      .then(projectNumber => {
        callback(projectNumber)
      })
      .catch(err => {
        app.debug('PageProject - _getProjectNumber Error: ', err)
        callback('') // eslint-disable-line standard/no-callback-literal
      })
  }

  _onSaveContactError (contactErr, contactData) {
    if (contactErr.message === 'Contact company already exists') {
      const errMsg = 'Contact ' + contactData.company + ' already exists'
      this.showError(errMsg)
    }
  }

  _onShowClientWizard = (projectData, clientName, copyProjectId) => {
    this.data.sidebarProject = projectData
    this.data.projectName = projectData.title
    this.data.clientName = clientName
    this.data.copyProjectId = copyProjectId
    this.data.sidebarContact = null

    this._showClientWizard()
  }

  _onEditClientWizard = (contactId, clientName, projectData, copyProjectId) => {
    this.data.sidebarProject = projectData
    this.data.projectName = projectData.title
    this.data.copyProjectId = copyProjectId
    this.data.clientName = clientName

    app
      .service('/api/contact')
      .get(contactId)
      .then(result => {
        this.data.sidebarContact = result
        this._showClientWizard()
      })
      .catch(contactErr => {
        app.debug('PageProject: _onEditClientWizard Error', contactErr)
      })
  }

  _onCloseContactSidebar = () => {
    this.setState({ isShowContactWizard: false, isShowAddProjectModal: true })
    this._refresh()
  }

  _onClickInfo = () => {
    this.setState({ isShowContactWizard: false, isShowAddProjectModal: true })
  }

  _onSaveContactDetails = (contactId, contactData) => {
    const { clientName } = this.data

    this.setState({ isShowContactWizard: false })
    contactData.teamId = app.getTeamId()

    if (clientName) {
      contactData.company = clientName
    }

    if (contactId) {
      app
        .service('/api/contact')
        .patch(contactId, contactData)
        .then(_contact => {
          if (this.data.sidebarProject) {
            this.data.sidebarProject.contactId = contactId
          }
          this.setState({ isShowAddProjectModal: true })
        })
        .catch(contactErr => {
          app.debug(
            'PageProject: _onSaveContactDetails Update Error',
            contactErr
          )
        })
    } else {
      app
        .service('/api/contact')
        .create(contactData)
        .then(contact => {
          if (this.data.sidebarProject) {
            this.data.sidebarProject.contactId = contact ? contact.id : null
          }
          this.setState({ isShowAddProjectModal: true })
        })
        .catch(contactErr => {
          app.debug(
            'PageProject: _onCreateContactDetails Create Error',
            contactErr
          )
          this._onSaveContactError(contactErr, contactData)
        })
    }
  }

  _onCreateContact = (clientName, callback) => {
    const contactData = {
      teamId: app.getTeamId(),
      company: clientName
    }

    app
      .service('/api/contact')
      .create(contactData)
      .then(contact => {
        if (this.data.sidebarProject) {
          this.data.sidebarProject.contactId = contact ? contact.id : null
        }
        if (callback) {
          callback(contact ? contact.id : '')
        }
      })
      .catch(contactErr => {
        app.debug(
          'PageProject: _onCreateContactDetails Create Error',
          contactErr
        )
        this._onSaveContactError(contactErr, contactData)
      })
  }

  _onSaveProjectDetails = (projectData, copyOptions) => {
    const { url, data, operationName } = getParametersForSaveProject(
      app.getTeamId(),
      app.loggedInId,
      projectData,
      copyOptions
    )
    app
      .service(url)
      .create({
        ...data,
        // adds by default the user that creates the project as PM
        projectManagerId: app.loggedInId,
        projectManagerName: app.loggedInUserTeam.displayName
      })
      .then(createRes => {
        app.debug(`PageProject: _onSaveProjectDetails ${operationName} Done`)
        this.setState({ isShowAddProjectModal: false })
        app.changePage('projectview-budget', createRes.id)
      })
      .catch(err => {
        app.debug(
          `PageProject: _onSaveProjectDetails ${operationName} Error`,
          err
        )
        this._onSaveProjectError(err)
      })
  }

  _onSaveProjectError (err) {
    if (err.message === 'Project name already exists for this client') {
      this.showError('project.form.msgProjectExists')

      this.setState({ isShowProjectError: true })
    } else {
      this.showError('project.form.msgErrorCreateProject')
    }
    if (err.message === 'Project number already exists') {
      this.showError('project.form.msgProjectNoExists')

      this.setState({ isShowProjectNumberError: true })
    }
  }

  _onCloseAddProjectModal () {
    this.setState({ isShowAddProjectModal: false })
    this._toggleDemoButton(true)
    this._toggleFABButton(true)
  }

  _refresh () {
    this.setState({ dataDate: new Date() })
  }

  _renderSettingsDialog () {
    const { project, loading } = this.state
    if (loading) {
      return ''
    }

    const bDisable = !!(project && project.status === 'closed')
    const colClass = bDisable
      ? 'actionboard-col2 alert-col2 disabled'
      : 'actionboard-col2 alert-col2'
    const bCanDelete = this.state.bCanDelete
    const colDeleteClass =
      bDisable || !bCanDelete
        ? 'actionboard-col2 alert-col2 disabled'
        : 'actionboard-col2 alert-col2'

    return (
      <DialogSetting
        ref={this._references.projectSettingDialog}
        onClose={this._onCloseSetting.bind(this)}
      >
        <div className='actionboard-row act-row'>
          <div className='actionboard-col2 alert-col2'>
            <div
              className='action-btn'
              onClick={this._onView.bind(this, project)}
            >
              <Button
                icon='action-search'
                className='button_dialog'
                canHover={false}
              />
              <span className='label'>
                <IntlMessage ident='project.list.actionView' />
              </span>
            </div>
          </div>
          <div className={colClass}>
            <div
              className='action-btn'
              onClick={!bDisable ? this._onEdit.bind(this, project) : null}
            >
              <Button
                icon='action-edit'
                className='button_dialog'
                canHover={false}
              />
              <span className='label'>
                <IntlMessage ident='project.list.actionEdit' />
              </span>
            </div>
          </div>
        </div>
        <div className='actionboard-row act-row'>
          <div className={colDeleteClass}>
            <div
              className='action-btn'
              onClick={
                !bDisable && bCanDelete
                  ? this._onDelete.bind(this, project)
                  : null
              }
            >
              <Button
                icon='action-delete'
                className='button_dialog button_dialogdlt'
                canHover={false}
                tooltipPosition='top'
                tooltip={
                  bDisable || !bCanDelete ? 'project.list.tipDelete' : ''
                }
              />
              <span className='label'>
                <IntlMessage ident='project.list.actionDelete' />
              </span>
            </div>
          </div>
          <div
            className='actionboard-col2 alert-col2'
            id='options-copy-project'
          >
            <div
              className='action-btn'
              onClick={this._onCopy.bind(this, project)}
            >
              <Button
                icon='action-copy'
                className='button_dialog'
                canHover={false}
              />
              <span className='label'>
                <IntlMessage ident='project.list.actionCopy' />
              </span>
            </div>
          </div>
        </div>
        <ConfirmDelete
          ref={this._references.confirmDelete}
          title='project.list.msgConfirmDelete'
          onClickOk={this._onClickDeleteConfirm.bind(this)}
        />
      </DialogSetting>
    )
  }

  _onRenderList (project, column, idx) {
    const info = {
      name: project.projectManagerName
    }

    return (
      <ProjectManagerCell
        info={info}
        onView={this._onListItemClick.bind(this, project)}
        width={column.width}
        key={idx}
      />
    )
  }

  _onListItemClick (project) {
    if (project && project.id) {
      app.changePage('projectview-overview', project.id)
    }
  }

  _onRenderGrid (project) {
    const projectSetting = app.projectSetting

    return (
      <ProjectItem
        project={project}
        showProjectNumber={projectSetting.useProjectNo}
        key={project.id}
        onView={this._onGridItemClick.bind(this)}
        onSettings={this._onGridItemSettingClick.bind(this)}
      />
    )
  }

  _renderProjectForm () {
    return (
      <ProjectForm
        ref={this._references.projectform}
        onSubmit={this._onSubmitProject.bind(this)}
        teamPaymentDays={this.data.teamPaymentPeriod}
        prefixCurrency={currency.symbol()}
        rateMarkup={app.getDefaulRateMarkup()}
        contactSearch={this._onSearchContact.bind(this)}
        onClose={this._onCloseForm.bind(this)}
        tagSuggestions={this.data.tagSuggestions}
        teamCountry={app.teamCountry}
        getProjectNumber={this._getProjectNumber.bind(this)}
      />
    )
  }

  _onGetActiveContacts (callback) {
    const params = {
      query: {
        archived: false,
        $select: ['_id', 'company']
      }
    }
    app
      .service('/api/contact')
      .find(params)
      .then(result => {
        if (result.data) {
          const options = result.data.map(obj => ({
            name: obj.company,
            id: obj.id
          }))
          callback(options)
        } else {
          callback([]) // eslint-disable-line standard/no-callback-literal
        }
      })
      .catch(err => {
        app.debug('PageContact: getDataContact err', err)
        callback([]) // eslint-disable-line standard/no-callback-literal
      })
  }

  _onSearchContact (keyword, callback) {
    if (keyword) {
      const pattern = keyword
        .replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
        .replace(/\$/g, '$$$$')
      const params = {
        query: {
          company: { $regex: pattern, $options: 'i' },
          $select: ['_id', 'company', 'archived'],
          $limit: 15
        }
      }

      app
        .service('/api/contact')
        .find(params)
        .then(result => {
          if (result.data) {
            const options = result.data.map(obj => ({
              label: obj.company,
              value: obj.id,
              bArchived: obj.archived
            }))
            callback(options)
          } else {
            callback([]) // eslint-disable-line standard/no-callback-literal
          }
        })
        .catch(err => {
          app.debug('PageContact: getDataContact err', err)
          callback([]) // eslint-disable-line standard/no-callback-literal
        })
    } else {
      callback([]) // eslint-disable-line standard/no-callback-literal
    }
  }

  _onSearchMember (keyword, callback) {
    if (keyword) {
      const pattern = keyword
        .replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
        .replace(/\$/g, '$$$$')
      const params = {
        query: {
          $or: [
            { firstName: { $regex: pattern, $options: 'i' } },
            { lastName: { $regex: pattern, $options: 'i' } }
          ],
          $select: ['userId', 'firstName', 'lastName']
        }
      }
      params.query.teamId = app.getTeamId()

      app
        .service('/api/users/team')
        .find(params)
        .then(result => {
          if (result.data) {
            const userIds = result.data.map(obj => obj.userId)
            const projectParams = {
              query: {
                userId: userIds,
                $client: { userDetail: true }
              }
            }
            app
              .service('/api/projectuser')
              .find(projectParams)
              .then(prjUserRes => {
                if (prjUserRes.data) {
                  const options = []
                  prjUserRes.data.map(projuser => {
                    const filterItem = _.find(
                      options,
                      item => item.value === projuser.userId
                    )
                    if (!filterItem) {
                      options.push({
                        label: projuser.displayName,
                        value: projuser.userId
                      })
                    }
                  })
                  callback(options)
                }
              })
              .catch(projUserErr => {
                app.debug('PageContact: _onSearchMember err', projUserErr)
                callback([]) // eslint-disable-line standard/no-callback-literal
              })
          } else {
            callback([]) // eslint-disable-line standard/no-callback-literal
          }
        })
        .catch(err => {
          app.debug('PageContact: getDataContact err', err)
          callback([]) // eslint-disable-line standard/no-callback-literal
        })
    } else {
      callback([]) // eslint-disable-line standard/no-callback-literal
    }
  }

  _onSearchTag (keyword, callback) {
    this._onCommonFilterTagSearch(keyword, [], callback)
  }

  _reloadData () {
    // this._updatePageState(this.data.pageState);
    this._getData(true)
  }

  _getData (bReload) {
    // Start profiler
    const profilerId = this._profiler ? this._profiler.start() : 0
    const skip = (this.data.pageNo - 1) * 20
    const params = {
      query: {
        pageIdent: this._pageIdent,
        bUpdatePageState: bReload,
        pageState: this.data.pageState,
        project: {
          $limit: 20,
          $skip: skip,
          $client: {
            subObjects: {
              contact: ['company', 'image'],
              projectManager: ['image']
            }
          }
        }
      }
    }

    app.service('/api/page/project').timeout = 15000
    app
      .service('/api/page/project')
      .find(params)
      .then(pageProjectRes => {
        this._onPageDataRecieved(pageProjectRes.pageData)

        this.data.projects =
          this.data.pageNo > 1
            ? this.data.projects.concat(pageProjectRes.projects)
            : pageProjectRes.projects
        this.data.tagSuggestions = pageProjectRes.tagSuggestions
        this.data.total = pageProjectRes.totalProjects
        this.data.countLoaded = params.query.$limit * this.data.pageNo
        this.data.canPaginate = !(this.data.countLoaded > this.data.total)
        this.data.defaultRateCards = pageProjectRes.rateCards

        this._onDataReceived(null, profilerId)
      })
      .catch(err => {
        app.debug('PageProject: _getDataProject err', err)
        this._onDataReceived(err, profilerId)
      })
  }

  _onUserStateRecieved (userState) {
    const pageState = this._getPageUserState(userState)
    if (pageState) {
      this.data.pageState = {
        sort: pageState.sort || 'title',
        sortAsc: pageState.sortAsc !== undefined ? pageState.sortAsc : true,
        type: pageState.type || 'grid',
        filter: pageState.filter || null
      }
    }
  }

  _onDataReceived (err, profilerId) {
    // Don't update state if component is already unmounted
    if (this._bUnMounted) return

    if (err) {
      app.debug('PageProject: _onDataReceived Error', err)
      this._setFABButtonVisible(false)
    } else {
      app.debug('PageProject: _onDataReceived [done]')
      if (this.data.projects && this.data.projects.length > 0) {
        this._setFABButtonVisible(true)
      } else {
        this._setFABButtonVisible(false)
      }
    }

    this.setState({
      isLoading: false,
      dataDate: new Date(),
      profilerId: profilerId
    })
  }

  _getListCloumns () {
    const projectSetting = app.projectSetting
    const bIsPMUniqVisible =
      projectSetting.useProjectNo && projectSetting.isPmVisible
    const columns = [
      {
        label: 'project.list.orderByProjectName',
        identifier: 'title',
        width: '26%',
        sort: true,
        filterType: 'autocomplete',
        type: 'link'
      },
      {
        label: 'project.list.orderByStatus',
        identifier: 'status',
        width: bIsPMUniqVisible ? '7%' : '10%',
        sort: true,
        filterType: 'autocomplete',
        type: 'status'
      },
      {
        label: 'project.list.orderByClientName',
        identifier: 'company',
        width: bIsPMUniqVisible ? '12%' : '15%',
        sort: true,
        filterType: 'autocomplete',
        type: 'text',
        field: 'contact'
      },
      {
        label: 'project.list.orderByProgress',
        identifier: 'percentageCompleted',
        width: bIsPMUniqVisible ? '9%' : '12%',
        sort: true,
        filterType: 'number',
        type: 'progress'
      },
      {
        label: 'project.list.orderByStartDate',
        identifier: 'startDate',
        width: bIsPMUniqVisible ? '9%' : '12%',
        sort: true,
        filterType: 'date',
        type: 'date'
      },
      {
        label: 'project.list.orderByDueDate',
        identifier: 'endDate',
        width: bIsPMUniqVisible ? '9%' : '12%',
        sort: true,
        filterType: 'date',
        type: 'date'
      }
    ]

    if (projectSetting.useProjectNo) {
      columns.unshift({
        label: 'project.list.orderByProjectNumber',
        identifier: 'projectNumber',
        width: '11%',
        sort: true,
        type: 'text'
      })
    }

    if (projectSetting.isPmVisible) {
      columns.push({
        label: 'project.list.orderByProjectManager',
        identifier: 'projectManagerName',
        width: '10%',
        sort: true,
        filterType: 'autocomplete',
        type: 'custom'
      })
    }

    return columns
  }

  _getSortOptions () {
    const projectSetting = app.projectSetting

    const sortOptions = [
      { label: 'project.list.orderByProjectNumber', value: 'projectNumber' },
      { label: 'project.list.orderByProjectName', value: 'title' },
      { label: 'project.list.orderByStatus', value: 'status' },
      { label: 'project.list.orderByClientName', value: 'company' },
      { label: 'project.list.orderByProgress', value: 'percentageCompleted' },
      { label: 'project.list.orderByStartDate', value: 'startDate' },
      { label: 'project.list.orderByDueDate', value: 'closeDate' }
    ]

    if (projectSetting.isPmVisible) {
      sortOptions.push({
        label: 'project.list.orderByProjectManager',
        value: 'projectManagerName'
      })
    }

    return sortOptions
  }

  _onPaginate () {
    if (this.data.canPaginate) {
      const page = this.data.pageNo + 1
      this.data.pageNo = page
      this._reloadData()
    }
  }

  _onSort (sort, sortAsc) {
    this.data.pageState.sort = sort
    this.data.pageState.sortAsc = sortAsc
    this.data.pageNo = 1
    this._reloadData()
  }

  _onSubmitProject (project, id, newClientName, contact) {
    if (newClientName) {
      contact.company = newClientName
      contact.addresses[0].country =
        contact.addresses.length > 0 && contact.addresses[0].country
          ? contact.addresses[0].country
          : app.teamCountry
      this._saveContact(contact, contactId => {
        if (contactId) {
          if (this._references.projectform.current) {
            this._references.projectform.current.onAfterContactCreated(
              contactId
            )
          }

          this._saveProject(project, id, contactId)
        }
      })
    } else {
      this._saveProject(project, id, project.contactId)
    }
  }

  _saveContact (contactObj, callback) {
    const contactPersons = []
    contactObj.contactPersons.map((personObj, _idx) => {
      if (personObj.name.trim() || personObj.email.trim()) {
        contactPersons.push({ name: personObj.name, email: personObj.email })
      }
    })
    contactObj.contactPersons = contactPersons

    app
      .service('/api/contact')
      .create(contactObj)
      .then(contact => {
        if (contact) {
          callback(contact.id)
        } else {
          callback(null)
        }
      })
      .catch(contactErr => {
        if (contactErr.message === 'Contact company already exists') {
          const errMsg = 'Contact ' + contactObj.company + ' already exists'
          this.showError(errMsg)
        }

        app.debug('PageProject: _saveContact Error', contactErr)
        callback(null)
      })
  }

  _saveProject (project, id, contactId) {
    project.contactId = contactId
    project.teamId = app.getTeamId()
    project.createdById = app.loggedInId
    if (id) {
      this._updateProject(project, id)
    } else {
      this._createProject(project)
    }
  }

  _createProject (createObj) {
    createObj.budget = {
      phases: [
        {
          title: '',
          fromDate: createObj.startDate ? createObj.startDate : null,
          toDate: createObj.endDate ? createObj.endDate : null,
          status: createObj.status,
          total: 0,
          percentage: 0,
          spentAmount: 0
        }
      ],
      totalSpent: 0,
      total: 0,
      noActiveTimeActivities: 1
    }

    app
      .service('/api/project')
      .create(createObj)
      .then(prjRes => {
        if (prjRes) {
          if (this._references.projectform.current) {
            this._references.projectform.current.hide()
          }

          app.changePage('projectview-budget', prjRes.id)
        }
      })
      .catch(prjErr => {
        app.debug('PageProject: _createProject Error', prjErr)

        if (prjErr.message === 'Project name already exists for this client') {
          if (this._references.projectform.current) {
            this._references.projectform.current.clearProjectName()
          }
          this.showError('project.form.msgProjectExists')
        } else {
          this.showError('project.form.msgErrorCreateProject')
        }
        if (prjErr.message === 'Project number already exists') {
          this.showError('project.form.msgProjectNoExists')
        }
      })
  }

  _updateProject (updateObj, prjId) {
    app
      .service('/api/project')
      .patch(prjId, updateObj)
      .then(_prjRes => {
        if (this._references.projectform.current) {
          this._references.projectform.current.hide()
        }
      })
      .catch(prjErr => {
        if (prjErr.message === 'Project number already exists') {
          this.showError('project.form.msgProjectNoExists')
        } else {
          this.showError('project.form.msgErrorUpdateProject')
        }
      })
  }

  _triggerAdd () {
    if (this.props.showadd) {
      this.onAdd()
    }
  }

  /* Realtime Events */
  _initEvents () {
    this._eventHandlers.projectCreated = this._eventReload.bind(
      this,
      'Project',
      'Created'
    )
    this._eventHandlers.projectUpdated = this._eventReload.bind(
      this,
      'Project',
      'Updated'
    )
    this._eventHandlers.projectRemoved = this._eventReload.bind(
      this,
      'Project',
      'Removed'
    )
    this._eventHandlers.projectPatched = this._eventReload.bind(
      this,
      'Project',
      'Patched'
    )

    const projectService = app.service('/api/project')
    projectService.on('created', this._eventHandlers.projectCreated)
    projectService.on('updated', this._eventHandlers.projectUpdated)
    projectService.on('removed', this._eventHandlers.projectRemoved)
    projectService.on('patched', this._eventHandlers.projectPatched)
  }

  _releaseEvents () {
    const projectService = app.service('/api/project')
    projectService.off('created', this._eventHandlers.projectCreated)
    projectService.off('updated', this._eventHandlers.projectUpdated)
    projectService.off('removed', this._eventHandlers.projectRemoved)
    projectService.off('patched', this._eventHandlers.projectPatched)

    this._eventHandlers.projectCreated = null
    this._eventHandlers.projectUpdated = null
    this._eventHandlers.projectRemoved = null
    this._eventHandlers.projectPatched = null
  }

  _eventReload (objectName, eventName, eventData) {
    if (eventfilters.teamFilter(eventData)) {
      app.debug(`-- Event - PageProject - ${objectName} - ${eventName} --`)
      this.data.pageNo = 1
      this._reloadData()
    }
  }

  /* Header Functions - START */
  renderHeader () {
    const { pageState } = this.data
    const filter = pageState.filter || {}
    const actions = [
      {
        ident: 'export',
        icon: 'download-solid',
        tooltip: 'project.list.tipExport',
        tooltipPosition: 'bottom',
        onClick: () => this._onExport()
      }
    ]

    const filterActions = [
      {
        ident: 'export',
        icon: 'download',
        tooltip: 'project.view.tipDownloadProjects',
        tooltipPosition: 'bottom',
        className: 'filterdownload',
        type: 'invert',
        onClick: () => this._onExport()
      }
    ]

    const filters = [
      {
        ident: 'status',
        type: 'option',
        label: 'project.list.filterAll',
        options: [
          { label: 'project.list.filterAll', ident: 'all' },
          { label: 'project.list.filterEstimate', ident: 'estimate' },
          { label: 'project.list.filterActive', ident: 'active' },
          { label: 'project.list.filterCompleted', ident: 'completed' },
          { label: 'project.list.filterClosed', ident: 'closed' }
        ],
        isMulti: false,
        value: filter.status || '',
        defaultValue: 'all'
      },
      {
        type: 'label',
        label: 'project.list.projectsFor'
      },
      {
        ident: 'contact',
        type: 'tag',
        label: 'project.list.filterAllClients',
        placeholder: 'project.list.searchClient',
        isMulti: false,
        value: filter.contact || null
      },
      {
        type: 'label',
        label: 'project.list.with'
      },
      {
        ident: 'member',
        type: 'tag',
        label: 'project.list.filterAllTeamMembers',
        placeholder: 'project.list.searchTeamMember',
        isMulti: false,
        value: filter.member || null
      },
      {
        type: 'label',
        label: 'project.list.taggedWith'
      },
      {
        ident: 'tags',
        type: 'tag',
        label: 'project.list.filterAllTags',
        placeholder: 'project.list.searchTags',
        isMulti: true,
        value: filter.tags || []
      }
    ]

    const projectSetting = app.projectSetting

    if (projectSetting.isPmVisible) {
      filters.push(
        {
          type: 'label',
          label: 'project.list.projectManagerWith'
        },
        {
          ident: 'projectmanager',
          type: 'tag',
          label: 'project.list.projectManager',
          placeholder: 'project.list.projectManager',
          isMulti: false,
          value: filter.projectmanager || null
        }
      )
    }

    return (
      <PageHeader
        ref={this._references.header}
        title='project.list.title'
        placeholderSearch={
          projectSetting.useProjectNo
            ? 'project.list.searchPlaceholderWithProjectNumber'
            : 'project.list.searchPlaceholder'
        }
        icon={<ProjectsIcon width={25} />}
        hasFilter
        hasSearch
        filters={filters}
        showGridList
        isGridActive={pageState.type === 'grid'}
        keywordSearch={filter.keyword}
        onGridListToggle={this._onHeaderGridListToggle.bind(this)}
        onChange={this._onHeaderChangeFilter.bind(this)}
        onSearchTags={this._onHeaderSearchTags.bind(this)}
        actions={actions}
        filterActions={filterActions}
      />
    )
  }

  _onExport () {
    this._references.exportDialog.current.show()
  }

  _renderInvoiceDialog () {
    const actions = [
      {
        onClick: () => this._onClickExport('xlsx'),
        buttonText: 'project.list.buttonXlsx',
        labelText: 'project.list.exportXlsxLabel'
      },
      {
        onClick: () => this._onClickExport('csv'),
        buttonText: 'project.list.buttonCsv',
        labelText: 'project.list.exportCsvLabel'
      }
    ]

    return (
      <DialogExport
        ref={this._references.exportDialog}
        title='project.list.exportTitle'
        unitsTitle='project.list.title'
        numberOfRecords={this.data.total}
        actions={actions}
      />
    )
  }

  _onClickExport (fileType) {
    const data = {
      userId: app.loggedInId,
      fileType: fileType
    }

    const exportParams = {
      query: {
        pageIdent: this._pageIdent,
        pageState: this.data.pageState,
        bUpdatePageState: false,
        clientTimezoneOffset: DateUtil.getLocalTimezoneOffset(),
        subObjects: {
          project: {
            contact: ['company'],
            items: []
          }
        }
      }
    }

    this._references.exportDialog.current.setIsLoading(true)

    app
      .service('/api/project/export')
      .create(data, exportParams)
      .then(result => {
        this._references.exportDialog.current.setIsLoading(false)
        app.redirect(
          `/export/${app.getTeamId()}/projects/${result.fileType}/${
            result.fileName
          }`
        )
      })
      .catch(err => {
        this._references.exportDialog.current.setIsLoading(false)
        app.debug('PageProject: onClickExport error', err)
      })
  }

  _onHeaderGridListToggle (isGridActive) {
    this.data.pageState.type = isGridActive ? 'grid' : 'list'
    this._updatePageState(this.data.pageState)

    this.setState({ dataDate: new Date() })
  }

  _onHeaderChangeFilter (filter) {
    this.data.pageState.filter = filter
    this.data.pageNo = 1

    this._reloadData()
  }

  _onHeaderSearchTags (filterIdent, keyword, callback) {
    if (filterIdent === 'member') {
      this._onSearchMember(keyword, callback)
    } else if (filterIdent === 'contact') {
      this._onCommonFilterContactSearch(keyword, callback)
    } else if (filterIdent === 'tags') {
      const excludeTags = []
      if (this.data.pageState.filter && this.data.pageState.filter.tags) {
        this.data.pageState.filter.tags.forEach(tag => {
          if (tag) {
            excludeTags.push(tag.value)
          }
        })
      }

      this._onCommonFilterTagSearch(keyword, excludeTags, callback)
    } else if (filterIdent === 'projectmanager') {
      this._onCommonProjectManagerSearch(keyword, callback)
    }
  }

  _onCommonProjectManagerSearch (keyword, callback) {
    if (keyword) {
      const pattern = keyword
        .replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
        .replace(/\$/g, '$$$$')
      const params = {
        query: {
          projectManagerName: { $regex: pattern, $options: 'i' },
          $select: ['id', 'projectManagerName', 'projectManagerId']
        }
      }
      params.query.teamId = app.getTeamId()

      app
        .service('/api/project')
        .find(params)
        .then(result => {
          if (result.data) {
            const projectManagerIdsMap = {}
            const options = []

            result.data.forEach(project => {
              if (
                project.projectManagerId &&
                projectManagerIdsMap[project.projectManagerId] === undefined
              ) {
                projectManagerIdsMap[project.projectManagerId] = project

                options.push({
                  label: project.projectManagerName,
                  value: project.projectManagerId
                })
              }
            })

            callback(options)
          } else {
            callback([]) // eslint-disable-line standard/no-callback-literal
          }
        })
        .catch(err => {
          app.debug('PageContact: _onCommonProjectManagerSearch err', err)
          callback([]) // eslint-disable-line standard/no-callback-literal
        })
    } else {
      callback([]) // eslint-disable-line standard/no-callback-literal
    }
  }
  /* Header Functions - END */
}

export default PageProject
